import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './NavigationMenu.css';

interface NavigationMenuItem {
  id: string;
  nome: string;
  icona: string;
  url?: string;
  action?: () => void;
  requiresLogin: boolean;
  totalCount?: number;
  anomalyCount?: number;
}

interface NavigationMenuProps {
  isLoggedIn: boolean;
  isMenuOpen: boolean;
  toggleMenu: () => void;
  onLogout: () => void;
  userName?: string;
  isUserAdmin?: boolean;
  activeWidgetId: string | null;
  onSetActiveWidget: (widgetId: string | null) => void;
  usciteCount?: number;
  selectedUscitaCapogruppo?: string | null;
}

const NavigationMenu: React.FC<NavigationMenuProps> = ({ 
  isLoggedIn, 
  isMenuOpen,
  toggleMenu,
  onLogout,
  userName,
  isUserAdmin,
  activeWidgetId,
  onSetActiveWidget,
  usciteCount = 0,
  selectedUscitaCapogruppo,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const getMenuItems = (): NavigationMenuItem[] => {
    let items: NavigationMenuItem[] = [];

    if (isLoggedIn) {
      items.push(
        {
          id: 'dashboard',
          nome: 'Dashboard',
          icona: 'tachometer-alt',
          url: '/1',
          requiresLogin: true,
          action: () => {
            onSetActiveWidget(null);
          }
        }
      );
    }

    if (isLoggedIn) {
      items.push(
        { 
          id: 'uscite', 
          nome: usciteCount > 0 ? `${usciteCount} Uscite` : 'Uscite', 
          icona: activeWidgetId === 'uscite' ? 'calendar-check' : 'calendar-alt',
          requiresLogin: true, 
          action: () => onSetActiveWidget('uscite'), 
        },
        {
          id: 'uscitaDetail',
          nome: selectedUscitaCapogruppo || 'Dettaglio',
          icona: 'route',
          requiresLogin: true,
          action: () => onSetActiveWidget('uscitaDetail'),
        },
        {
          id: 'localita',
          nome: 'Località',
          icona: activeWidgetId === 'localita' ? 'map-marked-alt' : 'map-marker-alt',
          requiresLogin: true,
          action: () => onSetActiveWidget('localita'),
        },
        {
          id: 'todo',
          nome: 'Todo',
          icona: activeWidgetId === 'todo' ? 'check-circle' : 'tasks',
          requiresLogin: true,
          action: () => onSetActiveWidget('todo'),
        },
        {
          id: 'carico',
          nome: 'Carico',
          icona: 'truck-loading',
          requiresLogin: true,
          action: () => onSetActiveWidget('carico'),
        },
        {
          id: 'collaboratori',
          nome: 'Collaboratori',
          icona: 'users',
          requiresLogin: true,
          action: () => onSetActiveWidget('collaboratori'),
        },
        {
          id: 'foto',
          nome: 'Foto',
          icona: activeWidgetId === 'foto' ? 'images' : 'camera',
          requiresLogin: true,
          action: () => onSetActiveWidget('foto'),
        },
        {
          id: 'chat',
          nome: 'Chat',
          icona: activeWidgetId === 'chat' ? 'comment-dots' : 'comments',
          requiresLogin: true,
          action: () => onSetActiveWidget('chat'),
        }
      );
    }

    return items;
  };

  const menuItems = getMenuItems();

  useEffect(() => {
    console.log("NavigationMenu (serpa_react) - ActiveWidgetId:", activeWidgetId);
  }, [activeWidgetId]);

  useEffect(() => {
    console.log("NavigationMenu (serpa_react) - selectedUscitaCapogruppo:", selectedUscitaCapogruppo);
  }, [selectedUscitaCapogruppo]);

  const handleMenuItemClick = (item: NavigationMenuItem) => {
    console.log('Menu item clicked (serpa_react):', item.nome, 'Is currently active:', activeWidgetId === item.id);
    if (item.action) {
      item.action();
    }
    if (item.url) {
      navigate(item.url);
    }
  };

  const isActiveRoute = (url?: string) => {
    if (!url) return false;
    if (url === '/1' || url === '/') return location.pathname === '/1' || location.pathname === '/';
    return location.pathname === url;
  };

  const visibleMenuItems = menuItems;

  return (
    <>
      <nav className={`navigation-menu ${isMenuOpen ? 'open' : ''}`}>
        <div className="menu-container">
          {visibleMenuItems.length > 0 ? (
            <ul className="menu-items">
              {visibleMenuItems.map((item) => (
                <li key={item.id} className={`menu-item ${activeWidgetId === item.id ? 'widget-active-menu-item' : ''}`}>
                  <button 
                    onClick={() => handleMenuItemClick(item)}
                    className={`${isActiveRoute(item.url) ? 'active' : ''} ${activeWidgetId === item.id ? 'widget-button-active' : ''} ${item.id === 'uscitaDetail' && !selectedUscitaCapogruppo && activeWidgetId !== 'uscitaDetail' ? 'disabled' : ''}`}
                    disabled={item.id === 'uscitaDetail' && !selectedUscitaCapogruppo && activeWidgetId !== 'uscitaDetail'}
                  >
                    <i className={`fas fa-${item.icona}`}></i>
                    <span>{item.nome}</span>
                  </button>
                </li>
              ))}
            </ul>
          ) : (
            <div className="menu-message">Nessun menu disponibile.</div>
          )}
        </div>
      </nav>
    </>
  );
};

export default NavigationMenu; 